import { createFileRoute } from '@tanstack/react-router';

// The actual chat UI is mounted by the parent layout at
// apps/web/src/routes/_authed/chat.tsx so the runtime survives URL changes
// between /chat and /chat/$threadId. This route exists only so TanStack
// matches the `/chat/:threadId` URL.
export const Route = createFileRoute('/_authed/chat/$threadId')({
  component: () => null,
});
